import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteAtmCompany = ({ atmCompanyId }: { atmCompanyId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/AtmCompanies/DeleteAtmCompany/${atmCompanyId}`);
};

type QueryFnType = typeof deleteAtmCompany;

type UseDeleteAtmCompanyOptions = {
  atmCompanyId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteAtmCompany = ({ config }: UseDeleteAtmCompanyOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllAtmCompanies"]);
      addNotification(`Η Εταιρία Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteAtmCompany,
  });
};
